import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';

import BonusCleared from '../../components/Bonus/Cleared/Cleared';
import { ActionType } from '../../enums';

import { TXTCLI_Instant_Bonus_Cleared, TXTCLI_OK } from './Bonus.Cleared.messages.json';

export default {
  front: {
    view: BonusCleared,
    viewConfig: {
      title: { tag: TXTCLI_Instant_Bonus_Cleared },
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_OK },
          actionFunction: ({ notificationId }: ActionParams) => {
            dispatch.notification.delete({ notificationId });
            dispatch.modal.close('/mpnotifications');
          }
        }
      ]
    }
  }
};
